<template>
  <div
      :class="`custom-modal modal fade show modal-backdrop ${modalClass}`"
      aria-hidden="true"
      aria-labelledby="exampleModalLabel"
      @click="closeModal"
  >
    <div class="modal-close" @click="closeModal"></div>
    <div class="modal-dialog"
         @click.stop
    >
        <slot name="body">
          Modal body
        </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    modalClass: {
      type: String,
      default: '',
    },
    closeText: {
      type: String,
      default: 'Close'
    }
  },
  mounted() {
    window.addEventListener('keydown', this.escCloseModal);
  },
  destroy() {
    window.removeEventListener('keydown', this.escCloseModal);
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    escCloseModal(e) {
      if (this.show && e.key === 'Escape') {
        this.closeModal();
      }
    },
  },
};
</script>
<style scoped>
</style>
